import Translate from "../../../../src/mdx/api/endpoints/translate.mdx";
import * as React from 'react';
export default {
  Translate,
  React
};